import { useState } from 'react';
import { getFullUrl } from '../utils/utils';
const QUICK_QUOTE_API_URL = '/api/v5/quotes'

export const useQuickQuoteApi = () => {
  const [loading, setLoading] = useState(false);

  const getQuickQuote = async (payload) => {
    setLoading(true);

    const apiEndpoint = getFullUrl(QUICK_QUOTE_API_URL);

    try {
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || `Error: ${response.status}`);
      }

      return {
        success: true,
        data
      };
    } catch (error) {
      const errorMessage = 'Something went wrong. Please try again.';

      return { success: false, message: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  return { getQuickQuote, loading };
};
